var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaneBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.25,
    height: 33.947,
    viewBox: "0 0 32.25 33.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_material-flight",
    "data-name": "Icon material-flight",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_292",
    "data-name": "Trac\\xE9 292",
    d: "M15.27,13.5",
    transform: "translate(1.614 1.382)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_293",
    "data-name": "Trac\\xE9 293",
    d: "M35.25,26.763V23.368L21.671,14.882V5.546a2.546,2.546,0,0,0-5.092,0v9.335L3,23.368v3.395L16.579,22.52v9.335L13.184,34.4v2.546l5.941-1.7,5.941,1.7V34.4l-3.395-2.546V22.52Z",
    transform: "translate(0 0)",
    fill: "#303030"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneBlack);
export default __webpack_public_path__ + "static/media/plane-black.3dcb60367e442b369e9e815e59ea76f4.svg";
export { ForwardRef as ReactComponent };